import {
	Card,
	CardContent,
	CardHeader,
	CardTitle,
} from "@/components/primitives";
import { MessageSquare } from "lucide-react";
import type { QAResult } from "../types";

interface QAHistoryProps {
	qaResults: QAResult[] | null;
}

export function QAHistory({ qaResults }: QAHistoryProps) {
	if (!qaResults || !Array.isArray(qaResults) || qaResults.length === 0) {
		return null;
	}

	return (
		<Card className="border-2 shadow-xl bg-white/90 dark:bg-slate-800/90 backdrop-blur-sm">
			<CardHeader className="pb-4 border-b bg-gradient-to-r from-blue-50/50 to-indigo-50/50 dark:from-blue-950/20 dark:to-indigo-950/20">
				<div className="flex items-center gap-3">
					<div className="p-2 rounded-lg bg-gradient-to-br from-blue-500 to-indigo-600">
						<MessageSquare className="h-5 w-5 text-white" />
					</div>
					<div>
						<CardTitle className="text-xl sm:text-2xl font-semibold">
							Exploration Questions & Answers ({qaResults.length})
						</CardTitle>
					</div>
				</div>
			</CardHeader>
			<CardContent className="pt-6">
				<div className="space-y-4">
					{qaResults.map((qa, index) => (
						<div
							key={index}
							className="border-l-4 border-blue-500 dark:border-blue-400 pl-4 py-3 bg-blue-50/50 dark:bg-blue-900/10 rounded-r-lg"
						>
							<h5 className="font-semibold text-foreground mb-2">
								Q: {qa.question}
							</h5>
							<p className="text-muted-foreground leading-relaxed">
								{qa.answer}
							</p>
						</div>
					))}
				</div>
			</CardContent>
		</Card>
	);
}
